//#region src/bite_service_ports.ts
const BiteServicePorts = {
	Bureau: 6363,
	Flash: 6464,
	Garcon: 6365,
	Maitred: 6364,
	WebhookReceiver: 6366,
	Vitrine: 6367,
	RecommendationApp: 6368,
	ChromeOsApp: 5173,
	Pinata: 6369,
	McpApp: 6370
};
//#endregion
export { BiteServicePorts };

//# sourceMappingURL=bite_service_ports.js.map